import { FC } from 'react';

interface Props {
  name: string;
  address: string;
  city: string;
  zipCode: string;
  county?: string;
  latitude?: number | null;
  longitude?: number | null;
}

const FormattedAddress: FC<Props> = ({
  name,
  address,
  city,
  zipCode,
  county,
  latitude,
  longitude,
}) => (
  <>
    <b>{name}</b>, {address}, {zipCode} {city}
    {county && ` - ${county}`}
    {latitude != null && longitude != null && (
      <a
        href={`https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`}
        target="_blank"
        rel="noopener noreferrer"
        style={{ marginLeft: 6 }}
        title="Öppna i Google Maps"
      >
        <img alt="Google maps icon" height={12} src="/images/googlemapsiconsmall.png" width={12} />
      </a>
    )}
  </>
);

export default FormattedAddress;
